import type { Translate } from "@/lib/i18n/translate";
import { ld } from "@/lib/theme/light-dark";
import { H } from "../../hero-tokens";

export type TelefonCallStatusIcon =
  | "phone-outgoing"
  | "phone-missed"
  | "phone-incoming";

export type TelefonCall = {
  readonly box: string;
  readonly boxBg: string;
  readonly boxFg: string;
  readonly name: string;
  readonly number: string;
  readonly isVm: boolean;
  readonly isCall: boolean;
  readonly statusIcon: TelefonCallStatusIcon | "";
  readonly statusLabel: string;
  readonly statusColor: string;
  readonly transcript: string;
  readonly time: string;
  readonly assigned: boolean;
  readonly unassigned: boolean;
  readonly assignInit: string;
};

/** `t` is `useTranslations("marketing.moduleTelefonData")`. */
export function telefonCalls(t: Translate): readonly TelefonCall[] {
  return [
    {
      box: "PS",
      boxBg: ld("#F6E9EE", "#392e33"),
      boxFg: ld("#B05B79", "#e68ba9"),
      name: t("petraSommer"),
      number: "+49 30 9014530",
      isVm: false,
      isCall: true,
      statusIcon: "phone-outgoing",
      statusLabel: t("ausgehend"),
      statusColor: H.inkFaint,
      transcript: "",
      time: "13:08",
      assigned: true,
      unassigned: false,
      assignInit: "NH",
    },
    {
      box: "?",
      boxBg: ld("#EDEFF2", "#2d3034"),
      boxFg: ld("#9AA3B2", "#73767b"),
      name: t("unbekannt"),
      number: "+49 711 9959822",
      isVm: false,
      isCall: true,
      statusIcon: "phone-outgoing",
      statusLabel: t("ausgehend12Sek"),
      statusColor: H.inkFaint,
      transcript: "",
      time: "11:42",
      assigned: true,
      unassigned: false,
      assignInit: "NH",
    },
    {
      box: "?",
      boxBg: ld("#EDEFF2", "#2d3034"),
      boxFg: ld("#9AA3B2", "#73767b"),
      name: t("unbekannt"),
      number: "+49 151 6626274",
      isVm: true,
      isCall: false,
      statusIcon: "",
      statusLabel: "",
      statusColor: "",
      transcript: t("gutenTagIchRufe"),
      time: "18:17",
      assigned: false,
      unassigned: true,
      assignInit: "",
    },
    {
      box: "HN",
      boxBg: ld("#E7F2EB", "#29332d"),
      boxFg: ld("#3A7D5A", "#79bc96"),
      name: t("hausmeisterServiceNord"),
      number: "+49 175 5145491",
      isVm: true,
      isCall: false,
      statusIcon: "",
      statusLabel: "",
      statusColor: "",
      transcript: t("heizungGeprueftAllesOrdnung"),
      time: "15:49",
      assigned: true,
      unassigned: false,
      assignInit: "NH",
    },
    {
      box: "?",
      boxBg: ld("#EDEFF2", "#2d3034"),
      boxFg: ld("#9AA3B2", "#73767b"),
      name: t("unbekannt"),
      number: "+49 151 1761416",
      isVm: true,
      isCall: false,
      statusIcon: "",
      statusLabel: "",
      statusColor: "",
      transcript: t("ichWuerdeGernBesichtigungstermin"),
      time: "17:59",
      assigned: false,
      unassigned: true,
      assignInit: "",
    },
    {
      box: "MB",
      boxBg: ld("#E7EEF8", "#2c323a"),
      boxFg: ld("#3F6CB0", "#7cacf5"),
      name: t("michaelBauer"),
      number: "+49 151 1761416",
      isVm: false,
      isCall: true,
      statusIcon: "phone-missed",
      statusLabel: t("eingehenderAnrufVerpasst"),
      statusColor: ld("#C0453E", "#ff7e73"),
      transcript: "",
      time: "17:34",
      assigned: false,
      unassigned: true,
      assignInit: "",
    },
    {
      box: "WB",
      boxBg: ld("#EAF0F8", "#2b3037"),
      boxFg: ld("#3F6CB0", "#7cacf5"),
      name: t("wegBirkenallee"),
      number: "+49 89 5512000",
      isVm: false,
      isCall: true,
      statusIcon: "phone-incoming",
      statusLabel: t("eingehend"),
      statusColor: H.inkFaint,
      transcript: "",
      time: "12.06. 17:34",
      assigned: true,
      unassigned: false,
      assignInit: "NH",
    },
    {
      box: "KR",
      boxBg: ld("#F6E9EE", "#392e33"),
      boxFg: ld("#B05B79", "#e68ba9"),
      name: t("klausRichter"),
      number: "+49 89 5512000",
      isVm: false,
      isCall: true,
      statusIcon: "phone-outgoing",
      statusLabel: t("ausgehend"),
      statusColor: H.inkFaint,
      transcript: "",
      time: "12.06. 09:20",
      assigned: true,
      unassigned: false,
      assignInit: "NH",
    },
  ];
}
